import PubSub from "underpub-js";

var ListingResidenceCategories = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-ListingResidenceCategories',
	};

	$.extend(true, this.options, options);

};

ListingResidenceCategories.prototype.init = function() {

	var self = this;

};

export default ListingResidenceCategories;
